const QueryParams = require('../../../page/frontend/helpers/params');

function getFacets(params = {}) {
  const url = `/browse/search/facets?${QueryParams.toString(params)}`;

  return fetch(url, { credentials: 'same-origin' })
    .then(res => {
      if (res.status > 200) {
        return Promise.reject(res);
      } else {
        return Promise.resolve(res);
      }
    })
    .then(res => res.json());
}

module.exports = {
  getFacets,
};
